import React from "react";

const MyOffers = () => {
    return <div>My offers</div>;
};

export default MyOffers;
